export default "__VITE_ASSET__5k9B4bZ1__"